import { enhance, handle } from "@grrr/hansel";
import { onDomReady } from "@grrr/ready";
import { svgInline } from "./modules/svg";
import { imageFilter } from "./modules/image-filter";
import { mainImage, mainImageClick } from "./modules/main_image";
import { title } from "./modules/title";
import { iframe } from "./modules/iframe";
import { topbar } from "./modules/topbar";
import { smoothScroll, subMenu, subMenuSticky } from "./modules/submenu";
import { menuToggle } from "./modules/menu";
import { search, searchToggle } from "./modules/search";
import { social } from "./modules/social";
import { modeCookie, toMode } from "./modules/mode";
import { newsLetterSubmit } from "./modules/newsletter";
import { linkEffect } from "./modules/linkeffect";
import { fixWorksPositioning } from "./modules/fixes";
import { loginEnhancer } from "./modules/input";

onDomReady(function () {
    enhance(document.documentElement, {
        svgInline,
        loginEnhancer,
        imageFilter,
        modeCookie,
        iframe,
        mainImage,
        topbar,
        title,
        subMenu,
        smoothScroll,
        subMenuSticky,
        menuToggle,
        social,
        newsLetterSubmit,
        linkEffect,
        searchToggle,
        search,
        fixWorksPositioning,
    });
    handle(document.documentElement, {
        toMode,
        mainImageClick,
    });
});
